import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Services = () => {
  const { t } = useLanguage();
  const services = t.services.items.map((item, index) => ({
    ...item,
    icon: ["fa-robot", "fa-palette", "fa-code", "fa-brain"][index]
  }));

  return (
    <section id="services" className="py-24 px-6 bg-[#050505] relative">
      <div className="pexadia-watermark"></div>
      <div className="max-w-7xl mx-auto relative z-20">
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-1.5 mb-6 border border-[#d4af37]/30 rounded-full bg-[#d4af37]/5">
            <span className="text-[10px] font-black tracking-[0.2em] text-white uppercase">
              {t.services.badge}
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-serif mb-6 italic">
            {t.services.title1} <span className="gold-gradient">{t.services.title2}</span>
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto text-xl font-light leading-relaxed">
            {t.services.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="glass-card rounded-[2rem] p-8 hover:border-[#d4af37]/40 transition-all">
              <div className="w-16 h-16 rounded-full gold-bg flex items-center justify-center mb-6">
                <i className={`fas ${service.icon} text-black text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">{service.title}</h3>
              <p className="text-gray-300 leading-relaxed font-light mb-6">{service.desc}</p>
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <i className="fas fa-check text-[#d4af37]"></i>
                    <span className="text-gray-300 font-light">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

